export default "__VITE_ASSET__D1Odc2rI__"